module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [(_vm.showModal) ? _c('modal', {
    attrs: {
      "brand": _vm.brand,
      "campaign": _vm.campaign,
      "zone": _vm.zone
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flexContainer ai-c jc-sb m-jc-sa",
    attrs: {
      "id": "searchBar"
    }
  }, [_c('div', {
    attrs: {
      "id": "logoClient"
    }
  }, [_c('img', {
    staticClass: "imgBrand",
    attrs: {
      "src": _vm.brandLogo,
      "alt": "",
      "width": "140"
    }
  })]), _vm._v(" "), (_vm.$route.name !== 'Planos') ? _c('div', {
    staticClass: "mobileNot",
    attrs: {
      "id": "searchInputNotPlano"
    }
  }, [_c('div', {
    staticClass: "inputSearch iBlock"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.search),
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "id": "searchInput",
      "type": "search",
      "placeholder": _vm.$t('common.search')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit(_vm.selected !== null ? {
          search: _vm.search,
          type: _vm.selected
        } : {
          search: _vm.search
        });
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "selectSearch iBlock"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "uppercase selectBrand",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": ''
    }
  }, [_vm._v(_vm._s(_vm.$t("common.searchAll")))]), _vm._v(" "), _vm._l((_vm.optionsTypeFilter), function(option, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(_vm.getTranslate(option.terms.name)))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": 'shade'
    }
  }, [_vm._v("shades")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "btnSearch iBlock"
  }, [_c('button', {
    staticStyle: {
      "background": "none",
      "border": "none"
    },
    on: {
      "click": function($event) {
        _vm.getLinkParams({
          search: _vm.search,
          type: _vm.selected,
          offset: 1
        });
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-search primary-text fa-lg"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Planos') ? _c('div', {
    staticClass: "flexContainer ai-c jc-sb mobileNot",
    attrs: {
      "id": "searchInputWrapper"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "id": "searchInput",
      "type": "search",
      "placeholder": _vm.$t('plano.search_planogram')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit({
          search: _vm.search
        });
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ai-c"
  }, [(_vm.search !== '') ? _c('img', {
    staticClass: "cross",
    attrs: {
      "src": require("../../assets/cross.png"),
      "alt": "",
      "width": "10",
      "height": "10"
    },
    on: {
      "click": _vm.reset
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ai-c"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Planos',
        query: _vm.getLinkParams({
          search: _vm.search
        })
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "glass",
      "src": require("../../assets/loupe.png")
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "select flexContainer",
    attrs: {
      "id": "zoneCampaign"
    }
  }, [_c('ul', {
    staticClass: "list-inline mobileNot campaignName"
  }, [(Object.keys(_vm.rem3rchUser.user.brands).length > 1) ? _c('li', {
    staticClass: "list-inline-item",
    on: {
      "click": function($event) {
        _vm.modal('brand');
      }
    }
  }, [_c('div', {
    staticClass: "triangle pointer"
  }), _vm._v(" "), _c('span', {
    staticClass: "campaign uppercase pointer bold"
  }, [_vm._v(_vm._s(_vm.currentBrand.name))])]) : _c('li', {
    staticClass: "list-inline-item"
  }, [_c('div', {
    staticClass: "triangle"
  }), _vm._v(" "), _c('span', {
    staticClass: "campaign uppercase bold"
  }, [_vm._v(_vm._s(_vm.currentBrand.name))])]), _vm._v(" "), (_vm.zoneL.length > 1) ? _c('li', {
    staticClass: "list-inline-item",
    on: {
      "click": function($event) {
        _vm.modal('zone');
      }
    }
  }, [_c('div', {
    staticClass: "triangle pointer"
  }), _vm._v(" "), (_vm.currentZone.name != null) ? _c('span', [(_vm.currentZone.name.length < 13) ? _c('span', {
    staticClass: "campaign uppercase pointer bold"
  }, [_vm._v(_vm._s(_vm.currentZone.name))]) : (_vm.currentZone) ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: (_vm.currentZone.name),
      expression: "currentZone.name",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "campaign uppercase pointer bold"
  }, [_vm._v(_vm._s(_vm._f("trim")(_vm.currentZone.name)))]) : _vm._e()]) : _vm._e()]) : _c('li', {
    staticClass: "list-inline-item"
  }, [_c('div', {
    staticClass: "triangle"
  }), _vm._v(" "), (_vm.currentZone.name != null) ? _c('span', [(_vm.currentZone.name.length < 13) ? _c('span', {
    staticClass: "campaign uppercase bold"
  }, [_vm._v(_vm._s(_vm.currentZone.name))]) : (_vm.currentZone) ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: (_vm.currentZone.name),
      expression: "currentZone.name",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "campaign uppercase bold"
  }, [_vm._v(_vm._s(_vm._f("trim")(_vm.currentZone.name)))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.currentCampaign.name != null && _vm.campaignL.length > 1) ? _c('li', {
    staticClass: "list-inline-item",
    on: {
      "click": function($event) {
        _vm.modal('campaign');
      }
    }
  }, [_c('div', {
    staticClass: "triangle pointer"
  }), _vm._v(" "), _c('span', {
    staticClass: "campaign uppercase pointer bold"
  }, [_vm._v(" " + _vm._s(_vm.currentCampaign.name))])]) : _vm._e(), _vm._v(" "), (_vm.currentCampaign.name == null && _vm.campaignL.length > 1) ? _c('li', {
    staticClass: "list-inline-item",
    on: {
      "click": function($event) {
        _vm.modal('campaign');
      }
    }
  }, [_c('span', {
    staticClass: "campaign uppercase pointer bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("dashboardModule.allCampaign")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mobileOnly tabletNot mobileSearchWrapper flexContainer m-as-s m-fd-r m-ai-c m-jc-fs"
  }, [(_vm.mobileSearchDisplay === false) ? _c('div', {
    staticClass: "select abs tabletNot",
    attrs: {
      "id": "zoneCampaignMobile"
    }
  }, [(_vm.currentCampaign.shortName != null) ? _c('div', {
    staticClass: "bloc campaignName"
  }, [_c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.currentCampaign.shortName))])]) : _vm._e(), _vm._v(" "), (_vm.currentCampaign.shortName == null) ? _c('div', {
    staticClass: "campaignName bold"
  }, [_c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.$t("dashboardModule.allCampaignShort")))])]) : _vm._e(), _vm._v(" "), (_vm.currentCampaign.shortName && _vm.currentCampaign.shortName.length > 1) ? _c('div', {
    staticClass: "bloc zoneName"
  }, [_c('span', {
    staticClass: "triangle"
  }), _vm._v(" "), _c('span', {
    staticClass: "zoneNameText uppercase"
  }, [_vm._v(_vm._s(_vm.currentCampaign.shortName))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mobileSearchDisplay === false) ? _c('div', {
    staticClass: "mobileSearchButton",
    on: {
      "click": _vm.displayMobileSearch
    }
  }, [_c('i', {
    staticClass: "fas fa-search fa-1x",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mobileSearchDisplay) ? _c('div', {
    staticClass: "mobileSearchInputWrapper m-as-s m-f-10 m-ai-c flexContainer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "mobileSearchInput m-f-10",
    attrs: {
      "type": "text",
      "placeholder": "Search terms"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ai-c"
  }, [(_vm.mobileSearchDisplay) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Catalog',
        query: _vm.getLinkParams({
          search: _vm.search
        })
      }
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v(_vm._s(_vm.$t("common.ok")))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ai-c"
  }, [(_vm.search !== '') ? _c('img', {
    staticClass: "crossMob",
    attrs: {
      "src": require("../../assets/croix.png"),
      "alt": ""
    },
    on: {
      "click": _vm.reset
    }
  }) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0960906","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/SearchHeader.vue
// module id = 3395
// module chunks = 0